import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=13f74482&scoped=true&lang=html&"
import script from "./compare.vue?vue&type=script&lang=js&"
export * from "./compare.vue?vue&type=script&lang=js&"
import style0 from "./compare.vue?vue&type=style&index=0&id=13f74482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f74482",
  null
  
)

component.options.__file = "compare.vue"
export default component.exports